<template>
  <div class="centerx">
    <vs-table
      multiple
      id="loader"
      class="vs-con-loading__container"
      :sst="true"
      @search="handleSearch"
      @sort="handleSort"
      v-model="selected"
      @selected="handleSelected"
      max-items="3"
      :data="tableComputedData"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <!-- ITEMS PER PAGE -->
        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer mb-4 mr-4"
          v-if="showAdd"
        >
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ currentPage * per_page - (per_page - 1) }} -
              {{
                pageTotal - currentPage * per_page > 0
                  ? currentPage * per_page
                  : pageTotal
              }}
              of {{ totalData }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="per_page = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="per_page = 20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="per_page = 30">
              <span>30</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="per_page = 50">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="per_page = 100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <template v-for="(fName, indexTd) in dataStructure">
          <vs-th
            v-if="fName.showAsOption == 'yes'"
            :sort-key="indexTd"
            :key="indexTd"
            >{{ fName.label }}</vs-th
          >
        </template>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <template v-for="(fName, indexTd) in dataStructure">
            <template v-if="fName.showAsOption == 'yes'">
              <vs-td
                v-if="fName.type == 'aronSelect'"
                :data="data[indextr][indexTd]"
                :key="indexTd"
                >{{ decodeSelectValue(indextr, indexTd, fName.data) }}</vs-td
              >

              <vs-td
                v-else-if="fName.type == 'aronMultiSelect'"
                :data="data[indextr][indexTd]"
                :key="indexTd"
                >{{ decodeMultiSelectValue(indextr, indexTd) }}</vs-td
              >

              <vs-td
                v-else-if="fName.type == 'fakeColumn'"
                :data="data[indextr][indexTd]"
                :key="indexTd"
              >
                {{ data[indextr][indexTd] }} {{ test(data[indextr][indexTd]) }}
                <template slot="edit">
                  <vs-input v-model="data[indextr][indexTd]" />
                </template>
              </vs-td>

              <vs-td v-else :data="data[indextr][indexTd]" :key="indexTd">{{
                data[indextr][indexTd]
              }}</vs-td>
            </template>
          </template>
        </vs-tr>
      </template>
    </vs-table>
    <div>
      <vs-pagination :total="pageTotal" v-model="currentx" goto></vs-pagination>
    </div>
    <div class="flex flex-wrap-reverse centerx p-3 items-end">
      <!-- ADD NEW -->
      <div
        class="p-4 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
        @click="insertData()"
      >
        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">Insert This Item</span>
      </div>
    </div>
  </div>
</template>

<script>
import { alertMixin } from "../../../mixin/alertMixin";
import { axiosMixin } from "../../../mixin/axiosMixin";
import { helperMixin } from "../../../mixin/helperMixin";
import { mapGetters } from "vuex";
export default {
  mixins: [alertMixin, axiosMixin, helperMixin],
  data: () => ({
    qty: 2,
    showPopup: false, //this is a form type. if true, the popup will show
    operation: "add",
    dataStructure: {},
    tblData: [],
    selected: [],
    log: [],
    currentx: 1,
    pageTotal: 1,
    per_page: 10,
    sort_by: "id",
    sort_direction: "desc",
    totalData: 0,
    isMounted: false,
    //for sidebar form
    addNewDataSidebar: false,
    sidebarData: {},
    dynamicEndPoint: "",
  }), 
  props: {
    endPoint: {
      type: String,
    },
    filterEndpoint: {
      type: Object,
      default: {},
    },
  },
  computed: {
    ...mapGetters({
      getProfileId: "profile/getProfileId",
    }),
    currentPage() {
      if (this.isMounted) {
        return this.currentx;
      }
      return 0;
    },
    tableComputedData() {
      return this.tblData;
    },
    showAdd() {
      return !this.viewOnly;
    },
  },
  methods: {
    test(val) {
      val = 1;
    },
    startLoading() {
      this.$vs.loading({
        container: "#loader",
        scale: 0.6,
      });
    },
    closeLoading() {
      this.$vs.loading.close("#loader > .con-vs-loading");
    },
    decodeSelectValue(tr, td, options) {
      return this.arrayOfObjectFind(options, this.tblData[tr][td])[0].label;
    },
    decodeMultiSelectValue(tr, td) {
      return this.flattenJsonStringArray(this.tblData[tr][td], "label");
    },
    handleSort(key, direction) {
      this.sort_by = key;
      this.sort_direction = direction;
      this.getData("from sort");
    },
    handleSearch(searching) {
      console.log("search:", searching);
    },
    handleSelected(tr) {
      console.log("selected:", this.selected);
    },

    insertData() {
      console.log("selected:", this.selected); //this.addToObject(this.selected,this.filterEndpoint)

      //insertMultipleContractPRItems
      console.log("this.endPoint::::",this.endPoint);
      if (this.endPoint == "myContractItems") {
        this.dynamicEndPoint = "insertMultipleContractPRItems";
      } else {
        this.dynamicEndPoint = "insertMultipleItems";
      }
      this.aronPost(
        this.dynamicEndPoint,
        { items: this.selected, id: this.getProfileId },
        "",
        ""
      )
        .then((response) => {
          console.log("response.data.data:", response.data);
          this.$store.state.profile.showPopup = false;
          this.$emit("input", response.data);
        })
        .catch((error) => {
          alert("error");
          this.closeLoading();
        });
    },
    getData(from) {
      this.startLoading();
      var params = "page=" + this.currentx + "&per_page=" + this.per_page;
      var sort =
        "&sort_by=" + this.sort_by + "&sort_direction=" + this.sort_direction;
      this.aronPost(this.endPoint, this.filterEndpoint, params, sort)
        .then((response) => {
          if (response.status == 200) {
            console.log("data:", response.data);

            this.tblData = response.data.data;
            this.dataStructure = response.data.fields;
            this.totalData = response.data.meta.pagination.total;
            this.pageTotal = response.data.meta.pagination.total_pages;
            console.log("this.tblData:", this.tblData);
          }
          this.closeLoading();
        })
        .catch((error) => {
          // this.decodeErrorFromAxios(error);
          this.closeLoading();
        });
    },
  },

  mounted() {
    if (this.countObject(this.filterEndpoint) > 0) {
      this.getData("created");
    }
  },
};
</script>